import { render, staticRenderFns } from "./AttachmentsDialog.vue?vue&type=template&id=0da7540c&scoped=true&"
import script from "./AttachmentsDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsDialog.vue?vue&type=style&index=0&id=0da7540c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7540c",
  null
  
)

export default component.exports